// 시안(오퍼그룹 홈페이지 시안 결합본.html)의 x-dc 스크립트에서 옮겨온 상수 및 표시용 포맷 함수.

export const BIZ = [
  { label: '일반 소매·음식', mult: 10.0, cycle: '12개월' },
  { label: '프랜차이즈', mult: 11.0, cycle: '12개월' },
  { label: '온라인 커머스', mult: 10.5, cycle: '12개월' },
  { label: '기타 서비스', mult: 9.0, cycle: '12개월' },
];

// answer: [앞, 강조, 뒤] 세 조각으로 나눈 본문
export const VOICES = [
  {
    quote: '"지금 도입해야 하는데 한 번에 나갈 금액이 부담입니다"',
    answer: [
      '오퍼그룹이 해당 물품을 구매해 납품하고, 고객사는 ',
      '계약에 따라 대금을 나누어 납부',
      '합니다. 도입 시점을 늦추지 않아도 됩니다.',
    ],
  },
  {
    quote: '"세금 부담이 큰데 비용처리할 항목이 없습니다"',
    answer: [
      '이용 금액 전액에 대해 ',
      '매입 세금계산서 발급',
      '이 가능해, 부가세 환급과 소득세 절감을 함께 볼 수 있습니다.',
    ],
  },
  {
    quote: '"어떤 지원 제도를 받을 수 있는지 모릅니다"',
    answer: [
      '고용 지원금·제휴 혜택 등 ',
      '해당되는 제도만 골라',
      ' 정리해 안내하고, 신청 절차까지 함께 챙깁니다.',
    ],
  },
  {
    quote: '"자금은 필요한데 어떻게 활용해야 할지 모르겠습니다"',
    answer: [
      '문의 주시면 거래내용과 상황을 먼저 확인해 ',
      '맞춤형으로 설계',
      '합니다. 여유자금은 그대로 두고 확장하실 수 있습니다.',
    ],
  },
  {
    quote: '"사업을 확장하려는데 권리금이 부족합니다"',
    answer: [
      '권리금처럼 목돈이 들어가는 항목도 ',
      '맞춤 서비스로 부담을 나누어',
      ' 예정한 시기를 놓치지 않도록 돕습니다.',
    ],
  },
];

export const PROCESS_STEPS = [
  { no: '01', title: '상담신청', body: '회사명과 연락처를 남기거나 전화·카카오톡으로 문의' },
  { no: '02', title: '담당자 상담', body: '필요한 금액과 거래내용을 확인해 이용 가능한 방식을 안내' },
  { no: '03', title: '심사 및 계약', body: '사업장 매출과 거래내용을 바탕으로 심사 후 계약 체결' },
  { no: '04', title: '구매·납품 및 분할납부', body: '오퍼그룹이 물품을 구매해 납품하고 고객사는 계약에 따라 분할납부' },
];

export const NOTICES = [
  {
    title: '이용금액과 조건',
    body: '예상 이용금액은 참고용 수치이며, 실제 이용금액·납부조건은 거래내용과 심사 결과에 따라 달라집니다.',
  },
  {
    title: '수수료 안내',
    body: '정식 수수료 외 출장비나 별도 비용을 요구하지 않습니다. 모든 비용은 계약서에 명시됩니다.',
  },
  {
    title: '개인정보 처리',
    body: '입력하신 정보는 상담 목적으로만 사용하며, 조회 단계에서는 신용점수에 영향을 주지 않습니다.',
  },
];

export const REVIEWS = [
  { initial: '프', name: '프랜차이즈 A사', meta: '직영점 확대 · 약 7개월', quote: '"신규 매장에 들어가는 초기 비용 부담을 나눠 출점 시기를 늦추지 않았습니다. 기존 매장 운영자금도 그대로 지켰어요."', svc: '신규 출점', metricLabel: '직영점', metric: '3개 → 10개' },
  { initial: '프', name: '프랜차이즈 B사', meta: '원자재 공급 · 약 1년', quote: '"가맹점이 늘면서 커진 본사 원자재 부담을 나눠 필요한 물량을 계속 확보했습니다."', svc: '원자재 확보', metricLabel: '가맹점', metric: '100개 → 350개' },
  { initial: '병', name: '병원 C', meta: '의료기기 도입', quote: '"고가 장비 납부 부담을 나눠 필요한 시기에 도입했습니다. 진료 수요가 늘면서 매출도 함께 올랐어요."', svc: '장비 도입', metricLabel: '매출', metric: '약 1.5배' },
  { initial: '커', name: '이커머스 D사', meta: '상품·재고 확보 · 약 3개월', quote: '"판매량이 빠르게 늘어 재고를 먼저 확보했습니다. 품절로 놓치던 판매를 줄였어요."', svc: '재고 확보', metricLabel: '월매출', metric: '3천만 → 2억' },
  { initial: '자', name: '자영업 E', meta: '영업 규모 확대 · 6개월~1년', quote: '"확장 시점마다 필요한 비용을 한 번에 준비하지 않고 나누면서 규모를 꾸준히 키웠습니다."', svc: '시설 확장', metricLabel: '월매출', metric: '3천만 → 2억' },
  { initial: '제', name: '제조업 F사', meta: '설비 증설 · 약 5개월', quote: '"수주가 늘어 설비를 늘려야 했습니다. 대금을 나누어 납부하니 증설 시점을 미루지 않았어요."', svc: '설비 도입', metricLabel: '생산량', metric: '약 1.8배' },
  { initial: '외', name: '외식 G사', meta: '2호점 출점 · 약 4개월', quote: '"2호점 인테리어와 주방설비를 함께 준비했습니다. 1호점 운영자금은 건드리지 않았습니다."', svc: '신규 출점', metricLabel: '매장', metric: '1개 → 3개' },
  { initial: '유', name: '유통 H사', meta: '거래처 대금 분산', quote: '"거래처 결제일이 한 달에 몰려 있었는데, 필요한 물량만 나눠 납부하도록 설계해 주셨습니다."', svc: '원자재 확보', metricLabel: '납부기간', metric: '12개월' },
  { initial: '치', name: '치과 I', meta: '장비 교체', quote: '"장비 교체 시기를 놓치지 않았습니다. 세금계산서가 정상 발급되어 경비 처리에도 문제가 없었어요."', svc: '장비 도입', metricLabel: '이용금액', metric: '1억 2,000만원' },
  { initial: '학', name: '교육 J사', meta: '분원 개설 · 약 6개월', quote: '"분원 비품과 시설 비용을 나누어 납부하면서 개설 일정을 그대로 지켰습니다."', svc: '시설 확장', metricLabel: '분원', metric: '2개 → 5개' },
  { initial: '물', name: '물류 K사', meta: '차량·설비 도입', quote: '"차량 도입을 한 번에 지출하지 않아 운영자금에 여유가 생겼습니다."', svc: '설비 도입', metricLabel: '이용금액', metric: '2억원' },
  { initial: '뷰', name: '뷰티 L사', meta: '매장 리뉴얼', quote: '"리뉴얼 비용을 나누어 납부했습니다. 담당자가 가능한 방식을 먼저 정리해 줘서 결정이 빨랐어요."', svc: '시설 확장', metricLabel: '이용금액', metric: '4,500만원' },
];

export const REVIEW_STATS = [
  { value: '4.8', label: '평균 만족도' },
  { value: '90%', label: '재이용·소개 비율' },
  { value: '5영업일', label: '평균 심사 소요' },
  { value: '1,000곳+', label: '누적 제휴 기업' },
];

export const HERO_STATS = [
  { value: '1,000+', label: '누적 이용기업' },
  { value: '1,000억+', label: '누적 거래금액' },
  { value: '90%+', label: '재이용 고객 비율' },
  { value: '1st', label: '국내 최초 BNPL 파트너' },
];

export const HERO_POINTS = [
  '이용방식 미리 정하지 않아도 상담 가능',
  '계약에 따라 분할납부',
  '신청만으로 계약 진행 안 됨',
];

export const FAQS = [
  {
    q: 'BNPL 사용시 부채이력에 남나요?',
    a: 'BNPL은 대출이 아니기 때문에 부채이력에 남지 않습니다.',
  },
  {
    q: '현금을 직접 지급하는 서비스인가요?',
    a: '아닙니다. 오퍼그룹 BNPL은 일반적인 대출이나 현금지원 서비스가 아니며, 실제 사업상 거래내용을 확인한 후 이용 가능한 방식과 조건을 안내합니다.',
  },
  {
    q: 'BNPL 이용방식을 미리 선택해야 하나요?',
    a: '미리 선택하지 않아도 됩니다. 필요한 금액과 사용 목적을 알려주시면 담당자가 가능한 방식과 조건을 안내합니다.',
  },
  {
    q: '신청하면 바로 계약해야 하나요?',
    a: '아닙니다. 담당자 상담을 통해 가능 여부와 조건을 확인한 후 최종적으로 결정할 수 있습니다.',
  },
];

export const NEWS = [
  { tag: '공지', title: '설립 이후 매출 268.75% 상승', date: '2024.10.18' },
  { tag: '서비스', title: '부가서비스 제휴 혜택 확대 안내', date: '2024.09.02' },
  { tag: '제도', title: '청년고용지원금 조건 및 신청 방법 정리', date: '2024.08.14' },
  { tag: '공지', title: '제휴 기업 1,000곳 달성', date: '2024.07.26' },
  { tag: '서비스', title: 'BNPL 정산 주기 단축 적용 안내', date: '2024.06.11' },
  { tag: '제도', title: '매입 세금계산서 발행 절차 안내', date: '2024.05.03' },
];

export const PARTNER_TYPES = [
  { no: '01', title: '공급 제휴', body: '기업고객에게 제공할 물품·설비·서비스를 보유한 공급사의 제휴를 검토합니다.' },
  { no: '02', title: '고객 연결 제휴', body: '구매·도입이 필요한 기업고객을 연결해 주시는 파트너와 협력합니다.' },
  { no: '03', title: '서비스 연계', body: '기존 서비스에 BNPL 이용방식을 붙여 함께 제공하는 모델을 검토합니다.' },
  { no: '04', title: '협회 · 프랜차이즈 · 단체', body: '회원사·가맹점에 단체 조건으로 이용방식을 안내합니다.' },
];

export const PARTNER_STEPS = [
  { no: '01', title: '접수 및 상담', body: '문의 폼 또는 대표전화로 접수하면 사업 현황을 확인합니다.' },
  { no: '02', title: '담당자 배정 후 미팅', body: '업종을 이해하는 전담 담당자가 배정되어 조건을 협의합니다.' },
  { no: '03', title: '서류 제출', body: '사업자등록증 등 필요한 서류만 최소 단위로 요청합니다.' },
  { no: '04', title: '심사', body: '내부 기준에 따라 검토하고 결과를 투명하게 안내합니다.' },
  { no: '05', title: '계약서 작성', body: '계약 체결 후 서비스 연동과 운영 지원이 시작됩니다.' },
];

export const PARTNER_KINDS = ['공급 제휴', '고객 연결 제휴', '서비스 연계'];

export const CONTACT_TOPICS = [
  'BNPL 이용 문의',
  '설비·장비 도입',
  '원자재·재고 확보',
  '부가서비스 문의',
  '제휴 문의',
  '기타 문의',
];

/** 푸터 '개인정보처리방침'을 누르면 펼쳐지는 패널 내용 */
export const PRIVACY = {
  lead: '오퍼그룹은 개인정보 보호법에 따라 개인정보를 안전하게 처리합니다.',
  items: [
    '1. 개인정보의 처리 목적·항목·보유기간',
    '2. 개인정보의 제3자 제공',
    '3. 개인정보 처리업무의 위탁',
    '4. 개인정보의 파기',
    '5. 정보주체의 권리와 행사방법',
    '6. 안전성 확보조치 및 보호책임자',
  ],
  outsourcingTitle: '3. 개인정보 처리업무의 위탁',
  outsourcing: [
    {
      label: '수탁자',
      value: '담당 동반성장 파트너 사업자',
      // TODO: 수탁자 목록 페이지(또는 PDF)가 생기면 링크로 연결
      note: '현재 수탁자 목록 보기',
    },
    {
      label: '위탁업무',
      value:
        '고객 상담, 신청·계약 진행 안내, 관련 서류의 접수·전달, 진행상황 안내 및 고객 문의 전달',
    },
    {
      label: '보유 및 이용기간',
      value:
        '위탁업무 또는 담당 계약 종료 시까지. 다만 관계 법령에 따른 보존기간이 있는 경우 해당 기간까지',
    },
  ],
  effectiveDate: '2026. 09. 07.',
  versionNote: '위탁업무 또는 수탁자가 변경되면 지체 없이 반영합니다.',
};

export const COMPANY = {
  phone: '1544-3230',
  hours: '평일 09:00 – 18:00 (주말·공휴일 휴무)',
  ceo: '설빈경',
  bizNo: '644-87-02089',
  address: '경기 부천시 원미구 조마루로385번길 92',
  addressDetail: '부천테크노밸리u1센터 1013·1014·1015호',
  kakao: 'https://pf.kakao.com/_CLxmHG',
  naverMap:
    'https://map.naver.com/p/search/%EB%B6%80%EC%B2%9C%ED%85%8C%EC%BD%94%EB%85%B8%EB%B0%B8%EB%A6%ACu1%EC%84%BC%ED%84%B0',
  kakaoMap:
    'https://map.kakao.com/?q=%EB%B6%80%EC%B2%9C%ED%85%8C%EC%BD%94%EB%85%B8%EB%B0%B8%EB%A6%ACu1%EC%84%BC%ED%84%B0',
  // Google '지도 퍼가기'가 주는 /maps/embed 주소를 그대로 쓴다.
  // maps?q=...&output=embed 형태는 301 리디렉션을 타는데 그 응답에
  // X-Frame-Options: SAMEORIGIN 이 붙어 모바일 브라우저에서 프레임이 차단된다.
  googleMapEmbed:
    'https://www.google.com/maps/embed?pb=!1m3!2m1!1z6rK96riwIOu2gOyynOyLnCDsm5Drr7jqtawg7KGw66eI66Oo66GcMzg167KI6ri4IDkyIOu2gOyynO2FjOy9lOuFuOuwuOumrCBVMeyEvO2EsA!6i17!3m1!1sko!5m1!1sko',
};

// ── 표시용 포맷 ──────────────────────────────────────────────

export const toNumber = (v) => {
  const n = parseInt(String(v).replace(/[^0-9]/g, ''), 10);
  return Number.isNaN(n) ? 0 : n;
};

export const comma = (n) => Math.round(n).toLocaleString('ko-KR');

/** 만원 단위 숫자를 "N억 N,NNN만원" 형태로 변환 (1만원 단위 반올림) */
export const won = (man) => {
  const v = Math.max(0, Math.round(man));
  if (v >= 10000) {
    const eok = Math.floor(v / 10000);
    const rest = v % 10000;
    return rest ? `${eok}억 ${comma(rest)}만원` : `${eok}억원`;
  }
  return `${comma(v)}만원`;
};
